<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt10')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="goods">
            <img class="bg" src="../../../assets/image/one/hunt_goods.png" alt="">
            <div class="goods_tle">
                {{ usd }}USD{{ $t('hunt11') }}
            </div>

            <div class="goods_list">
                <div class="goods_list_box" v-for="el in goods.data" :key="el.id">
                    <img src="../../../assets/image/one/hunt_goods_box.png" alt="">
                    <div class="goods_xx">
                        <div class="goods_list_box_le">
                            <img :src="el.goods_image" alt="">
                        </div>
                        <div class="goods_list_box_ri">
                            <div class="glbr_text">{{ el.goods_name }}</div>
                            <div class="glbr_btn">
                                <img src="../../../assets/image/one/hunt_goods_pri.png" alt="">
                                <span>$ {{ el.usd }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img class="goods_logo" src="../../../assets/image/one/hunt_logo.png" alt="">
        </div>

    </div>
</template>


<script>
import { UsdActivityList } from '../../../api/memberOne'
export default {
    name: 'HuntGoods',
    data() {
        return {
            usd: '',
            page: 1,
            limit: 10,
            goods: []
        }
    },
    mounted() {
        const data = this.$route.query.data;
        this.usd = data
        this.onUsdActivityList()
    },
    created() {

    },
    methods: {
        onUsdActivityList() {
            const { usd, page, limit } = this
            UsdActivityList({
                usd, page, limit
            }).then(res => {
                if (res && res.result) {
                    this.goods = res.result
                }
            })
        }
    }

}
</script>


<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .goods {
        position: relative;
        flex: 1;

        .goods_tle {
            position: absolute;
            top: 12%;
            left: 50%;
            width: 100%;
            text-align: center;
            transform: translate(-50%, -50%);
            color: #fff;
            font-size: 32px;
            font-weight: bold;
        }

        .goods_list {
            position: absolute;
            top: 51%;
            width: 83%;
            left: 50%;
            height: 54%;
            overflow-y: auto;
            transform: translate(-50%, -50%);
            border-radius: 14px;

            .goods_list_box {
                display: flex;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .goods_xx {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    display: flex;
                }

                .goods_list_box_le {
                    width: 40%;
                    height: 100%;

                    img {
                        padding: 16px 24px;
                        box-sizing: border-box;
                    }
                }

                .goods_list_box_ri {
                    flex: 1;
                    padding: 16px 20px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;

                    .glbr_text {
                        flex: 1;
                        font-size: 16px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 2;
                        color: #fff;
                    }

                    .glbr_btn {
                        margin-top: 5px;
                        width: 100px;
                        height: 40px;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #FFE8C4;
                        font-size: 12px;

                        img {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }

                        span {
                            z-index: 1;
                        }
                    }
                }
            }
        }

        .goods_logo {
            position: absolute;
            top: 89%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 55%;
            // bottom: 4%;
        }
    }

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>
